__turbopack_context__.v({
  "content-description__copy": "rtVttq_content-description__copy",
  "content-description__copy--big-spacing": "rtVttq_content-description__copy--big-spacing",
  "content-description__icon": "rtVttq_content-description__icon",
  "content-description__title--size-lg": "rtVttq_content-description__title--size-lg",
  "content-description__title--size-sm": "rtVttq_content-description__title--size-sm",
});
